import { ThemeConfig } from "antd";

export const getThemeConfig = (): ThemeConfig | undefined => {
  return {
    token: {
      colorPrimary: "#2A8851",
      borderRadius: 5,
      colorBorder: "#2A8851",
    },
    components: {
      Input: {
        colorBgContainer: "white",
        colorBorder: "white",
      },
      Table: {
        headerBg: "#EFEFEF",
        headerBorderRadius: 14,
      },
      Button: {
        colorBgContainer: "#2A8851",
        colorBgBase: "#F4F6FA",
      },
      Select: {
        colorBgContainer: "#F4F6FA",
        colorBorder: "white",
      },
      DatePicker: {
        colorBgContainer: "#F4F6FA",
        colorBorder: "white",
      },
      Carousel: {
        dotHeight: 5,
        dotActiveWidth: 100,
        dotWidth: 100,
      },
      Segmented: {
        trackBg: "#E5F1E6",
        itemSelectedBg: "#006F01",
        itemSelectedColor: "#ffffff",
        itemHoverColor: "#006F01",
      },
      Form: {
        itemMarginBottom: 15,
      },
      Spin: {
        colorBgContainer: "#ffffff",
      },
    },
  };
};
